import { AppContainerComponent } from './core/components/app-container/app-container.component';
import { AuthGuardService } from './core/guards/auth.guard';
import { EulaGuardService } from './core/guards/eula.guard';
import { RedirectComponent } from './core/components/redirect/redirect.component';
import { Routes } from '@angular/router';
import { canActivateEmbed } from './core/guards/embed-auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('@app/core/auth/auth.module').then((m) => m.AuthModule)
  },
  {
    path: 'eula',
    loadChildren: () => import('@app/eligibility/pages/eula/eula.module').then((m) => m.EulaModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'download/:id',
    loadChildren: () =>
      import('@app/eligibility/pages/download-file/download-file.module').then(
        (m) => m.DownloadFileModule
      ),
    canActivate: [AuthGuardService]
  },
  {
    path: 'e',
    loadChildren: () => import('@app/embed/embed.module').then((m) => m.EmbedModule),
    data: { breadcrumb: { skip: true } },
    canActivate: [canActivateEmbed]
  },
  {
    path: 'app',
    data: { breadcrumb: { skip: true } },
    component: AppContainerComponent,
    children: [
      {
        path: '',
        redirectTo: 'eligibility',
        pathMatch: 'full'
      },
      {
        path: 'eligibility',
        loadChildren: () =>
          import('@app/eligibility/eligibility.module').then((m) => m.EligibilityModule),
        data: { breadcrumb: { skip: true } }
      },
      { path: '**', redirectTo: '' }
    ],
    canActivate: [AuthGuardService, EulaGuardService]
  },
  {
    path: 'redirect',
    component: RedirectComponent
  },
  {
    path: '**',
    redirectTo: 'app'
  }
];
